import React, { useEffect, useState } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import * as Font from 'expo-font';
import * as SplashScreen from 'expo-splash-screen'; // Import SplashScreen for better loading
// import MapboxGL from '@react-native-mapbox-gl/maps';

// Import screens
import WelcomeScreen from './screens/WelcomeScreen';
import LoginScreen from './screens/LoginScreen';
import SignUpScreen from './screens/SignUpScreen';
import ResetPasswordScreen from './screens/ResetPasswordScreen';
import TermsOfService from './screens/legal/TermsOfService';
import PrivacyPolicy from './screens/legal/PrivacyPolicy';
import CookiePolicy from './screens/legal/CookiePolicy';
import EligibilityScreen from './screens/EligibilityScreen';
import VerificationScreen from './screens/VerificationScreen';
import BuyerHomeScreen from './screens/BuyerHomeScreen';
import MapScreen from './screens/MapScreen';
import ListingsScreen from './screens/ListingsScreen';
import BuyerProfileScreen from './screens/BuyerProfileScreen';
import PropertyDetailScreen from './screens/PropertyDetailScreen';
import OfferScreen from './screens/OfferScreen';
import MessagesScreen from './screens/MessagesScreen';
import SellerHomeScreen from './screens/SellerHomeScreen';
import PostPropertyScreen from './screens/PostPropertyScreen';
import VerificationResultScreen from './screens/VerificationResultScreen';
import SellerProfileScreen from './screens/SellerProfileScreen';

// Import Favorites Context
import { FavoritesProvider } from './contexts/FavoritesContext'; // Ensure correct path

// Define types for navigation
export type RootStackParamList = {
  WelcomeScreen: undefined;
  LoginScreen: undefined;
  SignUpScreen: undefined;
  ResetPasswordScreen: undefined;
  TermsOfService: undefined;
  PrivacyPolicy: undefined;
  CookiePolicy: undefined;
  EligibilityScreen: undefined;
  VerificationScreen: undefined;
  BuyerHomeScreen: undefined;
  MapScreen: undefined;
  ListingsScreen: undefined;
  MessagesScreen: { propertyId: string }; 
  BuyerProfileScreen: undefined; 
  PropertyDetailScreen: { property: any };
  OfferScreen: undefined;
  SellerHomeScreen: undefined;
  PostPropertyScreen: undefined;
  VerificationResultScreen: undefined;
  SellerProfileScreen: undefined;
};

const Stack = createStackNavigator<RootStackParamList>();

SplashScreen.preventAutoHideAsync(); // Prevent splash screen from hiding until fonts load

const App = () => {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  // Load custom fonts
  const loadFonts = async () => {
    await Font.loadAsync({
      'aventra-bold': require('./assets/fonts/aventra-bold.ttf'),
      // Load other fonts if needed
    });
    setFontsLoaded(true);
    SplashScreen.hideAsync(); // Hide splash screen once fonts are loaded
  };

  useEffect(() => {
    loadFonts();
  }, []);

  if (!fontsLoaded) {
    return null; // Prevent rendering until fonts are loaded
  }

  return (
    <FavoritesProvider>
      <NavigationContainer>
        <Stack.Navigator initialRouteName="WelcomeScreen">
          <Stack.Screen name="WelcomeScreen" component={WelcomeScreen} />
          <Stack.Screen name="LoginScreen" component={LoginScreen} />
          <Stack.Screen name="SignUpScreen" component={SignUpScreen} />
          <Stack.Screen name="ResetPasswordScreen" component={ResetPasswordScreen} />
          <Stack.Screen name="TermsOfService" component={TermsOfService} />
          <Stack.Screen name="PrivacyPolicy" component={PrivacyPolicy} />
          <Stack.Screen name="CookiePolicy" component={CookiePolicy} />
          <Stack.Screen name="EligibilityScreen" component={EligibilityScreen} />
          <Stack.Screen name="VerificationScreen" component={VerificationScreen} />
          <Stack.Screen name="BuyerHomeScreen" component={BuyerHomeScreen} />
          <Stack.Screen name="MapScreen" component={MapScreen} /> 
          <Stack.Screen name="ListingsScreen" component={ListingsScreen} />
          <Stack.Screen name="BuyerProfileScreen" component={BuyerProfileScreen} />
          <Stack.Screen name="PropertyDetailScreen" component={PropertyDetailScreen} />
          <Stack.Screen name="OfferScreen" component={OfferScreen} />
          <Stack.Screen name="MessagesScreen" component={MessagesScreen} />
          <Stack.Screen name="SellerHomeScreen" component={SellerHomeScreen} />
          <Stack.Screen name="PostPropertyScreen" component={PostPropertyScreen} />
          <Stack.Screen name="VerificationResultScreen" component={VerificationResultScreen} />
          <Stack.Screen name="SellerProfileScreen" component={SellerProfileScreen} />
        </Stack.Navigator>
      </NavigationContainer>
    </FavoritesProvider>
  );
};

export default App;
